<template>
    <div v-if="getTechChildList">
        <tech-child-header :page-name="hdtext"></tech-child-header>
        <tech-child-list :list="getTechChildList"></tech-child-list>
    </div>
</template>

<script>
    import TechChildHeader from 'pages/commons/header/Header'
    import TechChildList from './components/List'

    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                loadStatus: 0
            }
        },
        components: {
            TechChildHeader,
            TechChildList
        },
        created () {
            this.loadTechChild()
        },
        destroyed () {
            this.resetTechChild()
        },
        watch: {
            $route (to, from) {
                this.resetTechChild()
                this.loadTechChild()
            },
            getTechChildLoadStatus () {
                this.loadStatus = this.getTechChildLoadStatus
            },
            loadStatus () {
                if (this.loadStatus == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (this.loadStatus == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (this.loadStatus == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            hdtext () {
                let name = this.$route.params.name
                let level = this.$route.params.level
                return name + "(L" + level + ")"
            },
            ...mapGetters(['getTechChildList'
                          ,'getTechChildLoadStatus'
            ])
        },
        methods: {
            resetTechChild () {
                this.$store.dispatch('resetTechChild')
            },
            loadTechChild () {
                this.$store.dispatch('loadTechChild', {
                    code: this.$route.params.code
                })
            }
        }
    }
</script>

<style>

</style>
